import { ICoordinates, IPickUpPoint, IWebSettings } from '@model';
import { dateInRange, getTodayDate } from '@utils/date';

import { IBenefits } from '../../pages';

export const hasFreeDeliveryForCart = (
  minimalPriceLimit: number,
  freeDelivery: boolean,
  freeDeliveryGlobalLimit: number,
  freeDeliveryGlobalFrom: Date,
  freeDeliveryGlobalTo: Date,
  benefits: IBenefits,
  priceProductsSummary: number,
  discountWithoutDelivery: number,
): boolean => {
  const isMinimalPriceLimit = minimalPriceLimit > 0;

  if (!benefits || !benefits.vouchers) {
    return false;
  }

  if (benefits.vouchers.some((voucher) => voucher.isDeliveryVoucher)) {
    return true;
  }

  if (!isMinimalPriceLimit) {
    return false;
  }

  let maxLimit = freeDeliveryGlobalLimit;

  // free delivery is DISABLED but deliveryType priceLimit is active
  // OR
  // free delivery is ENABLED and deliveryType priceLimit is active and lower thant global limit
  if (
    (!freeDeliveryFSEnabled(freeDelivery, freeDeliveryGlobalFrom, freeDeliveryGlobalTo) && isMinimalPriceLimit) ||
    (freeDeliveryFSEnabled(freeDelivery, freeDeliveryGlobalFrom, freeDeliveryGlobalTo) &&
      isMinimalPriceLimit &&
      minimalPriceLimit < freeDeliveryGlobalLimit)
  ) {
    maxLimit = minimalPriceLimit;
  }

  return priceProductsSummary - discountWithoutDelivery > maxLimit;
};

export const freeDeliveryFSEnabled = (
  freeDelivery: boolean,
  freeDeliveryGlobalFrom: Date,
  freeDeliveryGlobalTo: Date,
): boolean => freeDelivery && dateInRange(getTodayDate(), freeDeliveryGlobalFrom, freeDeliveryGlobalTo);

export const mergeWebSettingsWithCarriers = (
  webSettings: IWebSettings[],
  carrierList: IPickUpPoint[],
): IPickUpPoint[] =>
  carrierList.map((item) => {
    const settings = webSettings.find((setting) => setting.deliveryTypeId === item.deliveryTypeId);

    return {
      ...item,
      icon: settings?.icon ?? item.icon,
      colour: settings?.color ?? item.colour,
    };
  });

export const calculateRadiusInKm = (center: ICoordinates, corner: ICoordinates) => {
  const dx = Math.abs(center.latitude - corner.latitude);
  const dy = Math.abs(center.longitude - corner.longitude);
  return Math.sqrt(dx * dx + dy * dy) * 111;
};
